import { Organization } from '../../../store/services/api'
import OrgFooter from '../layouts/Footer/Footer.vue'
import OrgHeader from '../layouts/Header/Header.vue'

const organizationAPI = new Organization()

export default {
  components: {
    OrgHeader,
    OrgFooter,
  },
  props: {},
  data() {
    return {
      loading: false,
      form:{
        companyName: '',
        companyWebsite: '',
        industry: '',
        organizationType: '',
        templateType: '',
        enabled: []
      },
    }
  },
  created() {},
  methods: {
    onSubmit: async function(event){
      this.loading = true
      try {
        const enabledInSandbox = this.form.enabled.reduce((o, key) => ({...o, [key]: true}), {})

        const payload = {
          name: this.form.companyName,
          onboardSurveyAnswers: {
            website: this.form.companyWebsite,
            industry: this.form.industry,
            classification: this.form.organizationType,
            templateSelection: this.form.templateType,
            ...enabledInSandbox
          }
        }

        await organizationAPI.addOrganization(payload)
        this.$router.push({ path: '/enterprise/brand-config' })

        this.loading = false

      } catch (err) {
        this.loading = false
        this.$message.error('An error occured.');
      }
    }
  },
}